import { api } from '@cwd/lib/main';
import { CustomField } from '@shared/Root/Context.access';

export async function updateCustomField(customField: CustomField): Promise<CustomField> {
    return api.post('/Accounts/Current/CustomField', customField);
}
